import { render, staticRenderFns } from "./AddToRepos.vue?vue&type=template&id=4a06b477&"
import script from "./AddToRepos.vue?vue&type=script&lang=js&"
export * from "./AddToRepos.vue?vue&type=script&lang=js&"
import style0 from "./AddToRepos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports